
import React, { useState, useEffect, useMemo, Fragment, useRef } from "react";
import { Helmet } from "react-helmet";
import AddrPopup from "@components/AddrPopup";
import { comma, getAddress } from '@src/util/helper'
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import LoadScript from "@util/loadScript";
import { createOrder, fakeOrder, validate } from "@pages/common/common";
import { emailRegex } from "@util/helper";
import { showSnackbar } from "@context/SnackbarContext";
import { useSearchParams } from "react-router-dom";
import Footer from "@components/part/Footer";
import {
  Grid,
  Divider,
  Typography,
  useMediaQuery,
  useTheme,
  Container,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormControlLabel,
  Radio,
  Button,
  Checkbox,
  RadioGroup,
  IconButton,
  Paper,
} from '@mui/material'
import { HomeOutlined} from '@mui/icons-material'
import moment from "moment";
const PayResult = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate()
  const resultCode = searchParams.get("resultCode")
  const resultMsg= searchParams.get("resultMsg")
  const amount = searchParams.get("amount")
  const time = searchParams.get("time")?? moment().subtract('1', 'days').valueOf()
  const theme = useTheme()

  useEffect(() => {
    const timeOver = Math.abs(moment().diff(+time, 'minutes')) > 5
    if(timeOver) {
      navigate('/')
    }
  },[])

  return(
    <div style={{paddingTop:50, marginTop:50}}>
      <Container maxWidth='xs' style={{marginBottom:20}}>
        <Paper>
          <Grid container spacing={10}>
            <Grid item xs={12}>
              <Typography variant='h4' style={{fontWeight:'bold',textAlign:'center'}}>비상주 오피스 결제 결과</Typography>
            </Grid>
            <Grid item xs={12}>
               <Typography
                variant='h5'
                style={{ fontWeight: 'bold', textAlign: 'center', color: resultCode ==='0000' ? theme.palette.success.main  : theme.palette.error.main}}
              >
              {
                resultCode === '0000' ? (
                  <>결제 성공</>
                ) : (
                  <>결제 실패({resultCode})</> 
                )
              }     
              </Typography>
            </Grid>
            <Grid item xs={12}>
               <Typography style={{ textAlign: 'center' }}>
              {
                resultCode === '0000' ? (
                  <>총 {comma(amount)} 원을 결제하였습니다.</>
                ) : (
                  <>{resultMsg}</> 
                )
              }     
               </Typography>
            </Grid>
            <Grid item xs={12} style={{display:'flex', justifyContent:'center'}}>
              <IconButton size='large'  onClick={() => navigate('/')}>
                <HomeOutlined style={{fontSize:30}}/>
              </IconButton> 
            </Grid>
          </Grid>
        
        </Paper>
      </Container>
      <Footer />
    </div>
  )
}

export default PayResult
